import type { Order } from '@hero/schema';

/**
 * Display name of the CRM client on an order.
 *
 * Prefers `Order.client.name` (relations-v2); falls back to the first
 * destination beneficiary for legacy orders published before `Order.client`
 * existed. Returns `undefined` when neither is present so callers can skip
 * rendering a client label entirely.
 */
export const getOrderClientName = (order: Order | undefined): string | undefined => {
  const fromClient = order?.client?.name?.trim();
  if (fromClient) return fromClient;

  for (const dest of order?.destinations ?? []) {
    const name = dest?.beneficiary?.name?.trim();
    if (name) return name;
  }
  return undefined;
};
